/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function PauseIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "pause", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("rect", { x: 8, y: 7, width: 3, height: 11, fill: "currentColor" }),
        React.createElement("rect", { x: 14, y: 7, width: 3, height: 11, fill: "currentColor" })));
}
const ForwardRef = React.forwardRef(PauseIcon);
export default ForwardRef;
//# sourceMappingURL=pauseIcon.js.map